export const jobsActions = {
    GET_JOBS_EXECUTING : 'GET_JOBS_EXECUTING',
    RECEIVED_JOBS_EXECUTING : 'RECEIVED_JOBS_EXECUTING',

    GET_JOBS_EXECUTING_BY_PROJ : 'GET_JOBS_EXECUTING_BY_PROJ',
    RECEIVED_JOBS_EXECUTING_BY_PROJ : 'RECEIVED_JOBS_EXECUTING_BY_PROJ',

    GET_JOBS_EXECUTING_BY_ENV : 'GET_JOBS_EXECUTING_BY_ENV',
    RECEIVED_JOBS_EXECUTING_BY_ENV : 'RECEIVED_JOBS_EXECUTING_BY_ENV',

    GET_JOBS_EXECUTED : 'GET_JOBS_EXECUTED',
    RECEIVED_JOBS_EXECUTED : 'RECEIVED_JOBS_EXECUTED',

    GET_JOBS_EXECUTED_BY_PROJ : 'GET_JOBS_EXECUTED_BY_PROJ',
    RECEIVED_JOBS_EXECUTED_BY_PROJ : 'RECEIVED_JOBS_EXECUTED_BY_PROJ',

    GET_JOBS_EXECUTED_BY_ENV : 'GET_JOBS_EXECUTED_BY_ENV',
    RECEIVED_JOBS_EXECUTED_BY_ENV : 'RECEIVED_JOBS_EXECUTED_BY_ENV',

    GET_JOB_DATA : 'GET_JOB_DATA',
    RECEIVED_JOB_DATA: 'RECEIVED_JOB_DATA',
    SET_JOB_COMPLETION_PERCENTAGE:'SET_JOB_COMPLETION_PERCENTAGE',

    GET_JOB_EXECUTION : 'GET_JOB_EXECUTION',
    RECEIVED_JOB_EXECUTION : 'RECEIVED_JOB_EXECUTION',
    GET_JOB_DATA_BY_TASK_ID: 'GET_JOB_DATA_BY_TASK_ID',

    KILL_JOB: 'KILL_JOB'
};

const initState = {
    jobsExecuting: null,
    jobsExecutingByProj : null,
    jobsExecutingByEnv : null,
    jobsExecuted: null,
    jobsExecutedByProj: null,
    jobsExecutedByEnv: null,
    jobData: null,
    jobExecution: null
};

export const jobsReducer = (state = initState, action: any) => {
    switch (action.type) {
        case jobsActions.RECEIVED_JOBS_EXECUTING:
            return Object.assign({}, state, action.payload);

        case jobsActions.RECEIVED_JOBS_EXECUTING_BY_PROJ:
            return Object.assign({}, state, action.payload);

        case jobsActions.RECEIVED_JOBS_EXECUTING_BY_ENV:
            return Object.assign({}, state, action.payload);

        case jobsActions.RECEIVED_JOBS_EXECUTED:
            return Object.assign({}, state, action.payload);

        case jobsActions.RECEIVED_JOBS_EXECUTED_BY_PROJ:
            return Object.assign({}, state, action.payload);

        case jobsActions.RECEIVED_JOBS_EXECUTED_BY_ENV:
            return Object.assign({}, state, action.payload);

        case jobsActions.RECEIVED_JOB_DATA:
            return Object.assign({}, state, action.payload);

        case jobsActions.RECEIVED_JOB_EXECUTION:
            return Object.assign({}, state, action.payload);

        case jobsActions.SET_JOB_COMPLETION_PERCENTAGE:
            return Object.assign({}, state, action.payload);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/jobsReducer.ts